<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/contactList' }">联系人</el-breadcrumb-item>
                <el-breadcrumb-item>联系人{{type == '1' ? '编辑' : '新增',}}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submitDetailsData('ruleDetailsForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <el-form
                        :model="ruleForm"
                        :rules="rules"
                        ref="ruleDetailsForm"
                        :label-position="labelPosition"
                        class="details_temp2023"
                    >
                        <el-form-item label="code：" prop="code">
                            <el-input v-model="ruleForm.code" size="mini" placeholder="请输入代码" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="" prop=""> </el-form-item>
                        <el-form-item label="名称：" prop="name">
                            <el-input v-model="ruleForm.name" size="mini" placeholder="请输入名称" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="省份：" prop="province_name">
                            <el-select
                                filterable
                                v-model="ruleForm.province_name"
                                placeholder="请选择省份"
                                clearable
                                @change="provinceChange"
                                size="mini"
                            >
                                <el-option v-for="item in provincesOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="电话号码：" prop="phone_number">
                            <el-input
                                v-model="ruleForm.phone_number"
                                size="mini"
                                clearable
                                placeholder="请输入电话号码"
                                maxlength="12"
                            ></el-input>
                        </el-form-item>
                        <el-form-item label="城市：" prop="city_rid">
                            <el-select
                                v-model="ruleForm.city_name"
                                placeholder="请选择城市"
                                clearable
                                filterable
                                size="mini"
                                @change="cityChange"
                            >
                                <el-option v-for="item in cityOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="通讯地址：" prop="mail_address">
                            <el-input v-model="ruleForm.mail_address" size="mini" clearable placeholder="请输入通讯地址"></el-input>
                        </el-form-item>
                        <el-form-item label="实体类型：" prop="entity_type" v-if="type == 3 || type == 5">
                            <el-select
                                filterable
                                v-model="ruleForm.entity_type"
                                clearable
                                placeholder="请选择实体类型"
                                size="mini"
                                @change="typeChange"
                                :disabled="typeDisabled"
                            >
                                <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="是否为主联系人：" prop="main" v-if="type == 3 || type == 5 || type == 4">
                            <div style="width: 280px">
                                <el-switch v-model="ruleForm.main" active-color="#13ce66" inactive-color="#cccccc" @change="switchChange">
                                </el-switch>
                            </div>
                        </el-form-item>
                        <el-form-item label="账户：" prop="entity_name" v-if="typeLable == 'account'">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.entity_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入账户名称搜索"
                                :remote-method="remoteMethod"
                                :loading="parentLoading"
                                size="mini"
                                clearable
                                @change="parentChange"
                                :disabled="entityDisabled"
                            >
                                <el-option v-for="item in parentOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="合作方：" prop="entity_name" v-if="typeLable == 'partner'">
                            <el-select
                                style="width: 100%"
                                v-model="ruleForm.entity_name"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入合作方搜索"
                                :remote-method="remoteMain"
                                :loading="mainLoading"
                                size="mini"
                                clearable
                                @change="mainChange"
                                :disabled="entityDisabled"
                            >
                                <el-option v-for="item in mainOptions" :key="item.value" :label="item.label" :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="" prop=""> </el-form-item>
                        <el-form-item label="创建人：" prop="created_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.created_by ? ruleForm.created_by : '' }} 
                            </div>
                        </el-form-item>
                        <el-form-item label="上次修改人：" prop="updated_by" v-if="type == 1">
                            <div class="read_only">
                                {{ ruleForm.updated_by ? ruleForm.updated_by : '' }} 
                            </div>
                        </el-form-item>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
export default {
    name: 'contactEdit',
    data() {
        var checkPhone = (rule, value, callback) => {
            setTimeout(() => {
                if (value) {
                    var phone_reg = /^13[0-9]{1}[0-9]{8}$|15[0-9]{1}[0-9]{8}$|18[0-9]{1}[0-9]{8}|17[0-9]{1}[0-9]{8}$|14[0-9]{1}[0-9]{8}/;
                    var tel_reg = /^([0-9]{3,4}-)?[0-9]{7,8}$/;
                    if (!phone_reg.test(value) && !tel_reg.test(value)) {
                        callback(new Error('手机或电话号码格式不正确。如果是固定电话，必须形如(xxxx-xxxxxxxx)'));
                        return false;
                    } else {
                        callback();
                    }
                } else {
                    callback();
                }
            }, 300);
        };
        return {
            typeDisabled: false,
            entityDisabled: false,
            typeLable: '', //类型
            rid: '',
            title: '', //新增或编辑
            type: '', //1  编辑 2 新增
            activeNames: ['1'],
            parentOptions: [], //账户名称
            mainOptions: [], //主联系人
            parentLoading: false,
            mainLoading: false,
            provincesOptions: [], //省份列表
            cityOptions: [], //城市列表
            typeOptions: [
                //职务列表
                {
                    value: 'account',
                    label: '账户'
                },
                {
                    value: 'partner',
                    label: '合作方'
                }
            ],
            positionOptions: [
                //类型
                {
                    value: '内勤',
                    label: '内勤'
                },
                {
                    value: '外勤',
                    label: '外勤'
                },
                {
                    value: '负责人',
                    label: '负责人'
                }
            ],
            practiceOptions: [
                //角色列表
                {
                    value: '收货人',
                    label: '收货人'
                },
                {
                    value: '发票收件人',
                    label: '发票收件人'
                },
                {
                    value: '流向对接人',
                    label: '流向对接人'
                },
                {
                    value: '资质对接人',
                    label: '资质对接人'
                },
                {
                    value: '贷款对接人',
                    label: '贷款对接人'
                },
                {
                    value: '费用对接人',
                    label: '费用对接人'
                },
                {
                    value: '短信通知人',
                    label: '短信通知人'
                }
            ],
            parentlist: [],
            states: [],
            btnLoading: false,
            labelPosition: 'right',
            //基本信息内表单验证
            ruleForm: {
                code: '',
                name: '',
                province_name: '',
                city_rid: '',
                city_name: '',
                entity_name: '',
                account_name: '',
                partner_name: '',
                account_rid: '',
                partner_id: '',
                phone_number: '',
                mail_address: '',
                created_at: '',
                created_by: '',
                updated_at: '',
                updated_by: '',
                entity_type: '',
                main: false,
                entity_rid: ''
            },
            switchType: '2',
            practice: [], //角色
            rules: {
                code: [{ required: true, message: '请输入代码', trigger: 'blur' }],
                name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
                province_name: [{ required: true, message: '请选择省份', trigger: 'blur' }],
                city_rid: [{ required: true, message: '请选择城市', trigger: 'blur' }],
                main: [
                    {
                        required: true,
                        message: '请选择是否为主联系人',
                        trigger: 'change'
                    }
                ],
                entity_type: [{ required: true, message: '请选择实体类型', trigger: 'blur' }],
                entity_name: [{ required: true, message: '请输入选择', trigger: 'blur' }],
                phone_number: [{ validator: checkPhone, trigger: 'blur' }]
            },
            btnTitle: ''
        };
    },
    created() {
        this.type = this.$route.query.type;
        this.rid = this.$route.query.id;
        if (this.type == 1) {
            this.typeDisabled = true;
        } else if (this.type == 4) {
            this.typeDisabled = true;
            this.entityDisabled = true;
            this.typeLable = this.$route.query.entity_type;
        } else {
            this.typeDisabled = false;
        }
    },
    mounted() {
        if (this.type == 1 || this.type == 5) {
            this.getDetails(); //获取详情
        } else if (this.type == 4) {
            this.ruleForm = {
                code: '',
                name: '',
                province_name: '',
                city_rid: '',
                city_name: '',
                entity_name: this.$route.query.partner_name,
                account_name: '',
                partner_name: this.$route.query.partner_name,
                account_rid: '',
                partner_id: this.$route.query.partner_id,
                phone_number: '',
                mail_address: '',
                created_at: '',
                created_by: '',
                updated_at: '',
                updated_by: '',
                entity_type: this.$route.query.entity_type,
                main: false,
                entity_rid: this.$route.query.entity_rid
            };
        } else {
            this.ruleForm = {
                code: '',
                name: '',
                province_name: '',
                city_rid: '',
                city_name: '',
                entity_name: '',
                account_name: '',
                partner_name: '',
                account_rid: '',
                partner_id: '',
                phone_number: '',
                mail_address: '',
                created_at: '',
                created_by: '',
                updated_at: '',
                updated_by: '',
                entity_type: '',
                main: false,
                entity_rid: ''
            };
        }
        this.getProvinces(); //获取省份
        this.parentlist = this.states.map((item) => {
            return { value: `${item.rid}`, label: `${item.name}` };
        });
    },
    computed: {
        listSet() {
            return this.states.map((item) => {
                return { value: `${item.rid}`, label: `${item.name}` };
            });
        }
    },
    methods: {
        //类型选择
        typeChange(value) {
            this.typeLable = value;
        },
        switchChange(value) {
            if (value) {
                this.switchType = '1';
            } else {
                this.switchType = '2';
            }
        },
        //角色联动框搜索
        practiceChange(val) {
            if (val) {
                this.practice = val.toString();
            }
        },
        //获取省份
        getProvinces() {
            let params = {
                has_all: '0'
            };
            this.$api
                .provinces(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.provincesOptions = [];
                        let data = res.data;
                        data.forEach((value, index) => {
                            this.provincesOptions.push({
                                value: value.rid,
                                label: value.name
                            });
                        });
                    }
                })
                .catch((error) => {});
        },
        //省份改变请求当下省份下的城市
        provinceChange(val) {
            this.cityOptions = [];
            if (val) {
                this.ruleForm.city_name = '';
                let params = {
                    parent_rid: val
                };
                this.$api
                    .cities(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.cityOptions = [];
                            let data = res.data;
                            data.forEach((value, index) => {
                                this.cityOptions.push({
                                    value: value.rid,
                                    label: value.name
                                });
                            });
                        }
                    })
                    .catch((error) => {});
            } else {
                this.ruleForm.city_name = '';
                this.cityOptions = [];
            }
        },
        //城市改变联动框
        cityChange(val) {
            this.ruleForm.city_rid = val;
            this.ruleForm.city_name = val;
        },
        //账户名称远程搜索方法
        remoteMethod(query) {
            if (query !== '') {
                this.parentLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchAccounts(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.parentLoading = false;
                                this.parentOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.parentOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.parentLoading = false;
                this.parentOptions = [];
            }
        },
        //合作方远程搜索方法
        remoteMain(query) {
            if (query !== '') {
                this.mainLoading = true;
                let params = {
                    name: query
                };
                this.$api
                    .searchPartners(params)
                    .then((res) => {
                        if (res.code == 0) {
                            this.states = res.data;
                            setTimeout(() => {
                                this.mainLoading = false;
                                this.mainOptions = this.listSet.filter((item) => {
                                    return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
                                });
                            }, 200);
                        } else {
                            this.mainOptions = [];
                        }
                    })
                    .catch((error) => {});
            } else {
                this.mainLoading = false;
                this.mainOptions = [];
            }
        },
        //账户名称联动框改变
        parentChange(value) {
            this.ruleForm.entity_rid = value;
        },
        //主联系人联动框改变
        mainChange(value) {
            this.ruleForm.entity_rid = value;
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/contactList' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getDetails() {
            let params = {
                rid: this.rid
            };
            this.$api
                .contactDetail(params)
                .then((res) => {
                    if (res.code == 0) {
                        this.ruleForm = {
                            code: res.data.code,
                            name: res.data.name,
                            province_name: res.data.province_name,
                            city_name: res.data.city_name,
                            city_rid: res.data.city_rid,
                            entity_name: res.data.entity_name,
                            entity_rid: res.data.entity_rid,
                            entity_type: res.data.entity_type,
                            phone_number: res.data.phone_number,
                            mail_address: res.data.mail_address,
                            created_at: res.data.created_at,
                            created_by: res.data.created_by,
                            updated_at: res.data.updated_at,
                            updated_by: res.data.updated_by,
                            main: false
                        };
                        if (res.data.main == 2) {
                            this.ruleForm.main = false;
                        } else if (res.data.main == 1) {
                            this.ruleForm.main = true;
                        }
                        this.switchType = res.data.main;
                        this.typeLable = res.data.entity_type;
                    }
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submitDetailsData(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    if (this.type == 1) {
                        this.submitEditData(); //修改
                    } else {
                        this.submitAddData(); //新增
                    }
                } else {
                    return false;
                }
            });
        },
        //提交修改
        submitEditData() {
            let params = {
                city_rid: this.ruleForm.city_rid ? this.ruleForm.city_rid : '',
                code: this.ruleForm.code ? this.ruleForm.code : '',
                name: this.ruleForm.name ? this.ruleForm.name : '',
                phone_number: this.ruleForm.phone_number ? this.ruleForm.phone_number : '',
                mail_address: this.ruleForm.mail_address ? this.ruleForm.mail_address : '',
                rid: this.rid
            };
            this.$api
                .contactUpdate(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '修改成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        },
        //提交新增
        submitAddData() {
            let params = {
                city_rid: this.ruleForm.city_rid ? this.ruleForm.city_rid : '',
                code: this.ruleForm.code ? this.ruleForm.code : '',
                name: this.ruleForm.name ? this.ruleForm.name : '',
                phone_number: this.ruleForm.phone_number ? this.ruleForm.phone_number : '',
                mail_address: this.ruleForm.mail_address ? this.ruleForm.mail_address : '',
                entity_type: this.ruleForm.entity_type,
                entity_rid: this.ruleForm.entity_rid,
                main: this.switchType
            };
            this.$api
                .contactInsert(params)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '新增成功！',
                            type: 'success'
                        });
                        this.cancel();
                    }
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>